<dialog-draggable-header>Delete TPR?</dialog-draggable-header>

<mat-dialog-content>
  <div [formGroup]="form" class="container" *ngIf="this.data.fixtureBuilt; else notFixtureBuilt">
    <div class="row mt-2">
      <div class="col-4">Select an Option:</div>
      <mat-radio-group class="col" formControlName="selection">
        <div class="row">
          <mat-radio-button color="primary" [value]="TprDeleteOptions.PRE_SALABLE" class="col">
            Pre-salable
          </mat-radio-button>
          <mat-radio-button color="primary" [value]="TprDeleteOptions.SOURCING_CHANGE" class="col">
            Sourcing Change
          </mat-radio-button>
        </div>
        <div class="row">
          <mat-radio-button color="primary" [value]="TprDeleteOptions.POST_SALABLE" class="col">
            Post-salable
          </mat-radio-button>
          <mat-radio-button color="primary" [value]="TprDeleteOptions.END_OF_PRODUCTION" class="col">
            End of Production
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </div>

    <mat-divider class="my-2"></mat-divider>

    <div class="maxwidth" [ngSwitch]="form.get('selection').value">
      <div *ngSwitchCase="TprDeleteOptions.PRE_SALABLE">
        If you continue, then all NBR, PRD040, and ECM entries will be <span class="text-danger">deleted</span>
        permanently.
        <br /> <br />
        Are you sure you want to continue?
      </div>
      <div *ngSwitchCase="TprDeleteOptions.SOURCING_CHANGE">
        If you continue, then all NBR, PRD040, and ECM entries will be recorded as
        <span class="text-success">re-sourced</span>.
        <br /> <br />
        Are you sure you want to continue?
      </div>
      <div *ngSwitchCase="TprDeleteOptions.POST_SALABLE">
        Post-salable records can not be deleted until all ILM requirements are met.
      </div>
      <div *ngSwitchCase="TprDeleteOptions.END_OF_PRODUCTION">
        EOP Date:
        <mat-form-field>
          <mat-label>EOP Date</mat-label>
          <input matInput formControlName="date" [matDatepicker]="picker" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <div *ngIf="this.form.get('date').valid; else invalidDate">
          The TPR records can not be deleted.
          <br /> <br />
          The TPR records are not eligible for deletion until
          <span class="text-success">{{this.deletionDate()}}</span>.
          In addition, there must be no litigation holds or open tax year holds.
        </div>
        <ng-template #invalidDate>
          <br />
          Please select the End of Production date.
        </ng-template>
      </div>
      <div *ngSwitchDefault>
        Select an option above. Or, click the Close button below to cancel.
      </div>
    </div>
  </div>
  <ng-template #notFixtureBuilt>
    If you continue, then all NBR, PRD040, and ECM entries will be <span class="text-danger">deleted</span> permanently.
    <br /> <br />
    Are you sure you want to continue?
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions  class="mat-dialog-actions-end no-margin">
  <button mat-raised-button color="primary" *ngIf="canDelete()" (click)="remove()" (keypress.enter)="remove()">
    Yes
  </button>
  <button mat-raised-button mat-dialog-close>{{canDelete() ? 'No' : 'Close'}}</button>
</mat-dialog-actions>